import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private authenticationService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      this.authenticationService.isAuthenticated.subscribe((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          // not logged in so redirect to login page with the return url
          this.router.navigate(['/auth/login']);
          subscriber.next(false);
          subscriber.complete();
          return false;
        } else {
          subscriber.next(true);
          subscriber.complete();
          return true;
        }
      });
    });
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
